export const arrowDown = require("./files/arrow-down-s-line.svg");
export const arrowLeft = require("./files/arrow-left-s-line.svg");
export const arrowRight = require("./files/arrow-right-s-line.svg");
export const arrowUp = require("./files/arrow-up-s-line.svg");
export const mouse = require("./files/mouse-line.svg");
export const closeLine = require("./files/close-line.svg");